export const FontSizes = Array.from(Array(40).keys())
  .slice(10)
  .map((size) => {
    return {
      label: `FONT_SIZE_${size}`,
      value: size,
      prop: "fontSize",
    };
  });
